export default __webpack_public_path__ + "static/media/logo.c3d6d7ea.png";